import { ContentBlock } from "eddev/blocks"

const HTMLBlock = (props: ContentBlock) => {
  if (typeof props.innerHTML === "string") {
    return <div className="wysiwyg" dangerouslySetInnerHTML={{ __html: props.innerHTML }} />
  } else {
    return null
  }
}

function TableBlock(props: ContentBlock) {
  return <div className="wysiwyg-table" dangerouslySetInnerHTML={{ __html: props.innerHTML ?? "" }} />
}

export default {
  "core/paragraph": HTMLBlock,
  "core/heading": HTMLBlock,
  "core/list": HTMLBlock,
  "core/table": TableBlock,
  "core/quote": HTMLBlock,
  "core/pullquote": HTMLBlock,
  "core/video": HTMLBlock,
  // "core/embed": (props) => {
  //   return <div>{JSON.stringify(props)}</div>
  // },
}
